import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NewsletterListService } from './newsletter-list.service';
import { NewsletterItem } from '../models/newsletter.model';
import { LIST_SERVER_PAGINATION_INITIAL_STATE, ListServerPaginationStateModel } from '../../../../../common/models';
import { NotificationService } from '../../../../../common/services';
import { NewsletterListInitialState, NewsletterListLoad } from './newsletter-list.actions';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type NewsletterListStateModel = ListServerPaginationStateModel<NewsletterItem>;

const initialState: NewsletterListStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<NewsletterListStateModel>({
  name: 'newsletterList',
  defaults: initialState,
})
@Injectable()
export class NewsletterListState {
  constructor(private newsletterListService: NewsletterListService, private notificationService: NotificationService) {}

  @Selector()
  static getState(state: NewsletterListStateModel): NewsletterListStateModel {
    return state;
  }

  @Selector()
  static getItems(state: NewsletterListStateModel): NewsletterItem[] {
    return state.items;
  }

  @Selector()
  static getLoaded(state: NewsletterListStateModel): boolean {
    return state.loaded;
  }

  @Action(NewsletterListLoad)
  getDataProtectionNoticeList(
    ctx: StateContext<NewsletterListStateModel>,
    { payload }: NewsletterListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.newsletterListService.getNewsletterList(payload).pipe(
      map((newsletterListStateModel: NewsletterListStateModel) => {
        ctx.patchState({ ...newsletterListStateModel, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(NewsletterListInitialState)
  setInitialState(ctx: StateContext<NewsletterListStateModel>): void {
    ctx.setState(initialState);
  }
}
